import {
  PaymentCanceledState,
  PaymentCompleteState,
  PaymentExpiredState,
  PaymentInsufficientState,
  PaymentMintingState,
  PaymentPendingState,
  PaymentStatus,
  PaymentStatusState,
} from '../model/payment.types';

export const isPendingPayment = (s: PaymentStatusState): s is PaymentPendingState => {
  return s.status === PaymentStatus.WAITING_FOR_PAYMENT;
};

export const isInsufficientFundsPayment = (s: PaymentStatusState): s is PaymentInsufficientState => {
  return s.status === PaymentStatus.INSUFFICIENT_FUNDS;
};

export const isMintingStagePayment = (s: PaymentStatusState): s is PaymentMintingState => {
  return s.status === PaymentStatus.MINTING;
};

export const isAwaitingPayment = (
  s: PaymentStatusState,
): s is PaymentInsufficientState | PaymentPendingState | PaymentMintingState => {
  return isPendingPayment(s) || isInsufficientFundsPayment(s) || isMintingStagePayment(s);
};

export const isCompletedPayment = (s: PaymentStatusState): s is PaymentCompleteState => {
  return s.status === PaymentStatus.COMPLETED;
};

export const isExpiredPayment = (s: PaymentStatusState): s is PaymentExpiredState => {
  return s.status === PaymentStatus.EXPIRED;
};

export const isCanceledPayment = (s: PaymentStatusState): s is PaymentCanceledState => {
  return s.status === PaymentStatus.CANCELED;
};
